











































import mixins from 'vue-typed-mixins'
import DraftElement from '@/calendesk/sections/section/mixins/DraftElement'
import Page from '@/calendesk/models/DTO/Response/Page'
import { ButtonSizeType } from '@/calendesk/models/ButtonSizeType'
export default mixins(DraftElement).extend({
  props: {
    title: {
      type: String,
      default: 'More'
    },
    color: {
      type: String,
      default: 'wb_color_text__color__'
    },
    navbarAdditionalPages: {
      type: Array,
      default: () => Array<Page>()
    },
    buttonSize: {
      type: Number,
      default: ButtonSizeType.MEDIUM
    }
  },
  data () {
    return {
      showingMenu: false
    }
  },
  name: 'AdditionalPagesMenu'
})
